import { Formik } from "formik";
import React from "react";
import CommonModal from "../CommonModal";
import CustomPasswordInput from "../../Layouts/CustomPasswordInput";
import { Col } from "react-bootstrap";
import { useParams } from "react-router-dom";

const LockeModal = ({
  data,
  isShowNotifyModal,
  setIsShowNotifyModal,
  validationSchema,
  handleLockAlbum,
  isLocked,
}) => {
  const { folderID, projectID } = useParams();
  return (
    <>
      <CommonModal
        // backdrop="static"
        keyboard={false}
        showModal={isShowNotifyModal}
        setShowModal={() => {
          setIsShowNotifyModal(false);
        }}
        centered={true}
        className={"create-project-modal"}
        title={<h4>{isLocked ? "Unlock Album" : "Lock Album"}</h4>}
        content={
          <Formik
            validationSchema={validationSchema}
            initialValues={{
              password: "",
            }}
            onSubmit={(values, { resetForm, setFieldError }) => {
              let FormData = {
                project_id: projectID,
                lock_password: values?.password,
                album_id: JSON.stringify(data?.id),
              };

              handleLockAlbum(FormData, resetForm, setFieldError);
              setIsShowNotifyModal(false);
            }}
          >
            {({
              errors,
              values,
              touched,
              handleSubmit,
              setFieldValue,
              handleBlur,
              resetForm,
              isValid,
              dirty,
            }) => {
              return (
                <>
                  {isLocked ? (
                    <p className="mb-3">
                      Enter your current studio password for album unlocking.
                    </p>
                  ) : (
                    <p className="mb-3">
                      Please create a studio password to lock the album in
                      Family Photos Album.
                    </p>
                  )}

                  <Col lg={12}>
                    <CustomPasswordInput
                      name="password"
                      label={
                        isLocked
                          ? "Enter current studio password"
                          : "Enter studio password"
                      }
                      floatingLabel={true}
                      value={values?.password}
                      onBlur={handleBlur}
                      onChange={(e) => {
                        setFieldValue("password", e.target.value);
                      }}
                      hasError={touched?.password}
                      errorMsg={errors?.password}
                    />
                    {/* {unlockMessage?.status === false ? (
                      <span
                        className="error-message"
                        style={{ bottom: "-24px" }}
                      >
                        {unlockMessage?.message}
                      </span>
                    ) : (
                      ""
                    )} */}
                  </Col>

                  <div className={`text-end`}>
                    <button
                      disabled={errors?.password || !dirty}
                      className={`btn btn-primary`}
                      onClick={() => handleSubmit()}
                    >
                      {isLocked ? "Unlock" : "Lock"}
                    </button>
                  </div>
                </>
              );
            }}
          </Formik>
        }
      />
    </>
  );
};

export default LockeModal;
